<template>
    <div>
        <h6 v-if="isAdminOrSuperUser" style="font-weight: bold">
            {{ $t('history.label.SalesPrice') }}
        </h6>

        <h6 v-else style="font-weight: bold">{{ $t('history.label.Price') }}</h6>

        <div v-b-toggle.salesPriceCollapse @click="rotateIcon('sale')">
            <span class="pr-2"
                >{{ $t('history.label.Total') }}: {{ localizedNumber(getTotalPrice('sale')) }}</span
            >
            <font-awesome-icon
                icon="caret-right"
                size="sm"
                :rotation="salesPriceIconRotated ? '90' : null"
            />
        </div>

        <b-col v-for="(item, index) in shipmentInfo.salesPriceLines" v-bind:key="index">
            <b-collapse id="salesPriceCollapse">
                <span v-if="item">- {{ item.text }}: {{ localizedNumber(item.value) }}</span>
            </b-collapse>
        </b-col>
        <div class="mt-2" v-if="shipmentInfo.costPriceLines.length > 0">
            <h6 style="font-weight: bold">{{ $t('history.label.CostPrice') }}</h6>
            <div v-b-toggle.costPriceCollapse @click="rotateIcon('cost')">
                <span class="pr-2"
                    >{{ $t('history.label.Total') }}:
                    {{ localizedNumber(getTotalPrice('cost')) }}</span
                >
                <font-awesome-icon
                    icon="caret-right"
                    size="sm"
                    :rotation="costPriceIconRotated ? '90' : null"
                />
            </div>
            <b-col v-for="(item, index) in shipmentInfo.costPriceLines" v-bind:key="index">
                <b-collapse id="costPriceCollapse">
                    <span v-if="item">- {{ item.text }}: {{ localizedNumber(item.value) }}</span>
                </b-collapse>
            </b-col>
        </div>

        <div class="mt-2">
            <h6 style="font-weight: bold">{{ $t('history.label.CustomsAndInsurance') }}</h6>
            <span
                >{{ $t('history.label.Customs') }}: {{ shipmentInfo.customsAmount.currencyCode }}
                {{ localizedNumber(shipmentInfo.customsAmount.amount) }} <br
            /></span>
            <span
                >{{ $t('history.label.Insurance') }}:
                {{ shipmentInfo.insuranceAmount.currencyCode }}
                {{ localizedNumber(shipmentInfo.insuranceAmount.amount) }} <br
            /></span>
            <span v-if="shipmentInfo.payAccount"
                >{{ $t('history.label.PayAccount') }}: {{ shipmentInfo.payAccount }} <br/>
            </span>
            <span v-if="shipmentInfo.soldToAccountNumber">
              {{ $t('history.label.SoldToAccountNumber') }}: {{ shipmentInfo.soldToAccountNumber }} <br />
            </span>
            <span v-if="shipmentInfo.importOfRecordAccount !== null && shipmentInfo.importOfRecordAccount !== shipmentInfo.soldToAccountNumber">
              {{ $t('history.label.ImportOfRecordAccount') }}: {{ shipmentInfo.importOfRecordAccount }} <br />
            </span>
            <span>{{ $t('history.label.Incoterms') }}: {{ shipmentInfo.incoterms }} <br /></span>
        </div>
    </div>
</template>
<script>
import localization from '@/mixins/localizationMixin';
import viewOptions from '@/mixins/viewOptionsMixin';
import { mapGetters } from 'vuex';

export default {
    components: {},

    props: {
        shipmentInfo: { type: Object, required: true }
    },

    data() {
        return {
            salesPriceIconRotated: false,
            costPriceIconRotated: false
        };
    },

    mixins: [localization, viewOptions],

    computed: {
        ...mapGetters('core', ['isCustomer', 'isAdminOrSuperUser'])
    },

    methods: {
        getTotalPrice(type) {
            let total = 0;

            if (type === 'sale') {
                this.shipmentInfo.salesPriceLines.forEach((x) => {
                    total += x.value;
                });
            } else if (type === 'cost') {
                this.shipmentInfo.costPriceLines.forEach((x) => {
                    total += x.value;
                });
            }

            return total.toFixed(2);
        },

        rotateIcon(type) {
            if (type === 'sale') {
                this.salesPriceIconRotated = !this.salesPriceIconRotated;
            }

            if (type === 'cost') {
                this.costPriceIconRotated = !this.costPriceIconRotated;
            }
        }
    }
};
</script>

<style></style>
